import {date} from '@eitje/utils'
import ContractPart from './active_record/contract_part'

class ContractHolder extends ContractPart {
	static tableName = 'contractHolders'
	static sort = {field: 'start_date', direction: 'desc'}

	endDate() {
		return this.end_date && date(this.end_date)
	}
}

export default ContractHolder
